import loadProductModule from './modules/Product.module';
import loadGiftVoucherDynamicModule from './modules/GiftVoucher.module';
const loadGiftVoucherModule = (initialData) => ({
    hasRouter: false,
    modules: [loadProductModule(initialData), loadGiftVoucherDynamicModule()],
});
export default loadGiftVoucherModule;
